<template>
  <div class="stars-input">
    <input-group-head
      :label="label"
      :error="error"
      :large="large"
      :class="['stars-input__head', { large: large }]"
    />

    <div :class="['stars-input__inner-wrap', { 'value-labels': labelLeft || labelLeft }]">
      <div v-if="labelLeft" class="stars-input__label">
        {{ labelLeft }}
      </div>
      <stars-rating
        class="stars-input__input"
        :size="sizeStars"
        :value="value"
        :error-mode="!!error"
        interactive
        @input="onInput"
      />
      <div v-if="labelRight" class="stars-input__label">
        {{ labelRight }}
      </div>
    </div>
  </div>
</template>

<script>
import InputGroupHead from '@kit/input-group-head/input-group-head.vue';
import StarsRating from './review-stats/stars-rating.vue';

export default {
  name: "stars-input",

  components: {
    InputGroupHead,
    StarsRating
  },

  inject: ["adaptive"],

  props: {
    value:{
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      required: true,
    },
    large: {
      type: Boolean,
      default: false
    },
    labelLeft: {
      type: String,
      default: '',
    },
    labelRight: {
      type: String,
      default: '',
    },
    errorMessage: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      error: ''
    };
  },

  computed: {
    valid() {
      return this.checkValid();
    },

    sizeStars() {
      if (this.large) {
        if (this.adaptive.isDesktop || this.adaptive.isTablet) {
          return '56';
        }

        return '42';
      } else {
        return '24';
      }
    }
  },

  watch: {
    value() {
      if (this.error) {
        this.error = ''
      }
    }
  },

  methods: {
    onInput(val) {
      this.$emit('input', val)
    },
    checkValidOutside() {
      const isValid = this.checkValid();

      if (!this.checkValid()) {
        this.error = this.errorMessage;
      }

      return isValid;
    },
    checkValid() {
      if (this.required && this.value === 0) {
        return false;
      }

      return true;
    }
  }
}
</script>

<style lang="scss">
  .stars-input {
    &__inner-wrap.value-labels {
      display: flex;
      justify-content: space-around;
      align-items: center;
    }

    &__head {
      margin-bottom: 8px;

      &.large {
        margin-bottom: 16px;

        @include breakpoint("desktop") {
          margin-bottom: 24px;
        }
      }
    }

    &__input {
      justify-content: flex-start;

      &.large {
        justify-content: center;
      }
    }

    &__label {
      display: none;

      @include breakpoint("tablet") {
        color: $gray;
        font-size: 14px;
        display: block;
      }
    }
  }
</style>